module.exports = __webpack_public_path__ + "img/swap_horizontal_circle_opsz20.a8b9fa7c.svg";